function initListeners() {
  const listItem = document.querySelectorAll('.productGrid .list-menu__item'),
        listLabel = document.querySelectorAll('.productGrid .list-menu__item .facet-checkbox'),
        listLabelMob = document.querySelectorAll('.productGrid .list-menu__item .mobile-facets__label');

  listItem.forEach(el => {
    el.addEventListener('click', () => {
      changeFilter();
    })
  });

  function changeFilter() {
    listLabel.forEach(elem => {
      const input = elem.querySelector('input[type=checkbox]:checked');

      if (elem.classList.contains('facet-checkbox--disabled')) {
        elem.parentNode.classList.add('inactive');
      }

      if (input) {
        elem.parentNode.classList.add('selected');
      } else {
        elem.parentNode.classList.remove('selected');
      }
    });

    listLabelMob.forEach(elem => {
      const input = elem.querySelector('input[type=checkbox]:checked');

      if (elem.classList.contains('mobile-facets__label--disabled')) {
        elem.parentNode.classList.add('inactive');
      }

      if (input) {
        elem.parentNode.classList.add('selected');
      } else {
        elem.parentNode.classList.remove('selected');
      }
    });
  }
  changeFilter();
}